export default "__VITE_ASSET__db037ec6__"